import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import { UseFormSetValue } from 'react-hook-form'

import { CreateItemProps } from '@/components/pages/ConsoleItemCreate/template/ItemCreateForm'
import { tLabel, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type PersonalInformationRequirementsInputCellProps = {
  setValue: UseFormSetValue<CreateItemProps>
  personalInformationRequirements: string
}

export const personalInformationRequirementsValue = {
  none: 'none',
  nameAndTel: 'nameAndTel',
  nameAndTelAndAddress: 'nameAndTelAndAddress',
} as { [key: string]: PersonalInformationRequirementsValue }

export type PersonalInformationRequirementsValue =
  | 'none'
  | 'nameAndTel'
  | 'nameAndTelAndAddress'

export const PersonalInformationRequirementsInputCell: Cell<PersonalInformationRequirementsInputCellProps> =
  ({ setValue, personalInformationRequirements }) => {
    const { t } = useTranslation('consoleItemCreate')

    return (
      <CellFrame sx={{ pb: 7 }}>
        <Typography variant="h5">
          {t('personalInformationRequirementsLabel')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ pt: 2 }}>
          {t('personalInformationRequirementsDesc')}
        </Typography>

        <RadioGroup
          onChange={(_, value) => {
            setValue('personalInformationRequirements', value as any, {
              shouldDirty: true,
            })
          }}
          sx={{ display: 'flex', flexDirection: 'column', gap: 0, mt: 1 }}
          value={personalInformationRequirements}
        >
          <FormControlLabel
            value={personalInformationRequirementsValue.none}
            control={<Radio />}
            label={tLabel(
              'consoleItemCreate.personalInformationRequirementsType.none'
            )}
          />
          <FormControlLabel
            value={personalInformationRequirementsValue.nameAndTel}
            control={<Radio />}
            label={tLabel(
              'consoleItemCreate.personalInformationRequirementsType.nameAndTel'
            )}
          />
          <FormControlLabel
            value={personalInformationRequirementsValue.nameAndTelAndAddress}
            control={<Radio />}
            label={tLabel(
              'consoleItemCreate.personalInformationRequirementsType.nameAndTelAndAddress'
            )}
          />
        </RadioGroup>
      </CellFrame>
    )
  }
